import { ErrorCode } from 'react-dropzone';

import { translate, Translate } from '@/shared/i18n';

export const UNSUPPORTED_FILE_TYPE_ERROR_MESSAGE = translate('en', 'createProject.error.unsupportedFormat');
export const UNAVAILABLE_PUBLIC_LINK_ERROR_MESSAGE = translate('en', 'createProject.error.unavailablePublicLink');

export const ROOT_ERRORS = {
  planLimitsExceeded: 'planLimitsExceeded',
  srtMismatch: 'srtMismatch',
};

type GetUploadErrorMessageParams = {
  errorCode: ErrorCode;
  maxFiles?: number;
  maxSize?: number;
  t?: Translate;
};

export const getUploadErrorMessage = ({
  errorCode,
  maxFiles = 1,
  maxSize,
  t = (key, variables) => translate('en', key, variables),
}: GetUploadErrorMessageParams) => {
  const errorMessages = {
    default: t('createProject.error.somethingWentWrong'),
    [ErrorCode.FileInvalidType]: t('createProject.error.unsupportedFormat'),
    [ErrorCode.FileTooLarge]: maxSize
      ? t('createProject.error.fileTooLargeWithMax', { maxSize })
      : t('createProject.error.fileTooLarge'),
    [ErrorCode.FileTooSmall]: t('createProject.error.fileTooSmall'),
    [ErrorCode.TooManyFiles]: t(
      maxFiles > 1 ? 'createProject.error.maximumVideos' : 'createProject.error.maximumVideo',
      { count: maxFiles },
    ),
  };

  return errorMessages[errorCode] || errorMessages.default;
};

const getIsForbiddenLinkError = (error: unknown) =>
  typeof error === 'object' && error !== null && 'status' in error && error.status === 400;

export const getForbiddenLinkErrorMessage = (
  error: unknown,
  t: Translate = (key, variables) => translate('en', key, variables),
) =>
  getIsForbiddenLinkError(error)
    ? t('createProject.error.unavailablePublicLink')
    : t('createProject.error.somethingWentWrong');
